import { Box, styled } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { Footer } from 'src/components/footer/Footer';
import { FIXED_FOOTER_HEIGHT, NAVIGATION_STATE } from 'src/constants';
import { PATHS } from 'src/constants/paths';
import { StepContentContainer } from 'src/features/locations/scheduleComponents/ScheduleComponents.styled';
import { lang } from 'src/utils';

import {
  ScheduleComponentLayoutWrapper,
  StyledFilterContainer,
} from '../../ScheduleComponentPage.styled';
import { ScheduleComponentLayout } from '../scheduleComponentLayout';
import { ScheduleComponentPageSidebar } from '../scheduleComponentPageSidebar';

interface EditScheduleComponentProps {
  enabledSave: boolean;
  handleSaveClick: () => void;
  saveLabel: string;
}

const Container = styled(Box)`
  padding: 0 !important;
  height: calc(100vh - ${FIXED_FOOTER_HEIGHT}px - 20px) !important;
`;

export const EditScheduleComponent = (props: EditScheduleComponentProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const navigatedFromScheduleComponentListview =
    location.state?.from === NAVIGATION_STATE.FROM_SCHEDULE_COMPONENT_LISTVIEW;

  return (
    <Container>
      <StepContentContainer container spacing={2}>
        <StyledFilterContainer item xs={12} md={3}>
          <ScheduleComponentPageSidebar />
        </StyledFilterContainer>

        <ScheduleComponentLayoutWrapper item xs={12} md={9}>
          <ScheduleComponentLayout />
        </ScheduleComponentLayoutWrapper>
      </StepContentContainer>

      <Footer
        showFooterActions
        showArrow
        saveLabel={props.saveLabel}
        cancelLabel={lang.cancel}
        disableSave={!props.enabledSave}
        onCancel={() => {
          if (navigatedFromScheduleComponentListview) {
            navigate(
              PATHS.LOCATION_GROUP_SCHEDULE(location.state?.locationGroupId),
            );
          } else {
            navigate(-1);
          }
        }}
        onSave={props.handleSaveClick}
      />
    </Container>
  );
};
